import React from "react";
import { DetailCardProps } from "models/DetailCard";
import { Ingredient } from "models/Ingredient";
import { Step } from "models/Step";
import { Serving } from "models/Serving";

import "./index.scss";
import { ReactSVG } from "react-svg";

const DetailCard = ({ type, data }: DetailCardProps) => {
  const getTitle = () => {
    switch (type) {
      case "ingredients":
        return "Ingredients";

      case "originalRecipe":
        return "The Original Recipe";

      case "serving":
        return "Serving";

      default:
        return "";
    }
  };

  const Ingredient = ({ parts, name }: Ingredient) => (
    <div className="ingredient">
      {parts && (
        <span className="body-alternative accent-underline-s">
          {parts} PART
        </span>
      )}
      <span className="body">{name}</span>
    </div>
  );

  const Step = ({ step, stepDescription }: Step) => (
    <div className="step">
      <span className="body-alternative">{step}</span>
      <span className="body">{stepDescription}</span>
    </div>
  );

  const Serving = ({ text, icon }: Serving) => (
    <div className="serving">
      <span className="body">{text}</span>
      <ReactSVG
        className="icon"
        src={require(`assets/icon/glass/${icon}.svg`)}
      />
    </div>
  );

  return (
    data && (
      <div className="detail-card col-4">
        <h2 className="detail-card-title heading-4">{getTitle()}</h2>

        {type === "ingredients" &&
          data.ingredients.length &&
          data.ingredients.map(({ parts, name }: Ingredient, i) => (
            <Ingredient parts={parts} name={name} key={i} />
          ))}

        {type === "originalRecipe" &&
          data.originalRecipe.length &&
          data.originalRecipe.map((step: string, i: number) => (
            <Step step={i + 1} stepDescription={step} key={i} />
          ))}

        {type === "serving" && data.serving.text && (
          <Serving text={data.serving.text} icon={data.serving.icon} />
        )}
      </div>
    )
  );
};

export default DetailCard;
